import * as PSLib from 'poolside-js-lib';
import { default as trHU } from './hu_HU.json';
import { default as trUS } from './en_US.json';

PSLib.Utils.Locale.addExtension([ trHU, trUS ]);

PSLib.Utils.Locale.monitorErrors = process.env.REACT_APP_WARNING_ON_MISSING_TRANSLATION === "true";
export default PSLib.Utils.Locale;
